module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Dialog', {
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.handleCloseDialog()
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-col w-full h-full"
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "flex justify-between items-center pl-5 pr-4 pt-3.5"
  }, [_c('div', {
    staticClass: "flex items-center space-x-5"
  }, [(_vm.draft && _vm.draft.is_follow_up === true) ? _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('div', {
    staticClass: "flex items-center justify-center rounded-full h-5 w-5 bg-purple-light"
  }, [_c('img', {
    staticClass: "w-3 h-3 pl-0.5",
    attrs: {
      "src": "/static/roundtable_icons/sequence_icon.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-manrope text-gray-800"
  }, [_vm._v("Follow Up")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2 font-manrope text-gray-800 cursor-default"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": ("/static/roundtable_icons/" + _vm.type + "_icon_color.svg")
    }
  }), _vm._v(" "), (_vm.type !== '') ? _c('span', [_vm._v(_vm._s(_vm.type === 'written' ? 'Written RoundTable' : 'Verbal RoundTable'))]) : _vm._e()]), _vm._v(" "), (_vm.draft && _vm.draft.is_follow_up === false) ? _c('pl-menu', {
    ref: "courseMenu",
    attrs: {
      "direction": "left",
      "menuSize": 8
    }
  }, [(_vm.draft && _vm.draft.is_follow_up === false) ? _c('button', {
    staticClass: "flex items-center space-x-2.5 font-manrope text-gray-800 font-bold",
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2.5 hover:underline"
  }, [_c('img', {
    staticClass: "w-3 -mt-0.5",
    attrs: {
      "src": "/static/roundtable_icons/courses_icon.svg"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.courseSelection))])]), _vm._v(" "), _c('i', {
    staticClass: "fa-solid fa-chevron-down text-xs text-gray-600 hover:text-gray-800"
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "flex flex-col space-y-1.5 rounded-lg mt-0.5 text-sm shadow-lg px-1 py-1 font-manrope max-h-96",
    attrs: {
      "menu-content": ""
    }
  }, [_c('div', {
    staticClass: "w-full h-9 px-0.5"
  }, [_c('input', {
    staticClass: "bg-gray-50 w-full border border-solid border-gray-200 focus:border-gray-100 focus:ring-2 ring-offset-1 ring-primary px-3 rounded h-full",
    attrs: {
      "placeholder": "Search by your course..."
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "max-h-72 overflow-y-auto"
  }, _vm._l((_vm.getCoursesInstructor), function(c, index) {
    return _c('li', {
      key: index,
      staticClass: "flex justify-between items-center space-x-2 hover:bg-gray-100 px-3 py-2 cursor-pointer rounded-md",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleSelectCourse(c)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(c.title))]), _vm._v(" "), (_vm.courses.some(function (course) { return course.id === c.id; })) ? _c('i', {
      staticClass: "fa-solid fa-check text-gray-400"
    }) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.draft && _vm.draft.is_follow_up === true) ? _c('div', {
    staticClass: "flex items-center space-x-2.5 font-manrope text-gray-800 cursor-default"
  }, [_c('img', {
    staticClass: "w-3 -mt-0.5",
    attrs: {
      "src": "/static/roundtable_icons/courses_icon.svg"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.courseSelection))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [(_vm.isSaving) ? _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('div', {
    staticClass: "flex items-center justify-center"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/roundtable_icons/cloud-upload.svg"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-manrope text-xs text-gray-800"
  }, [_vm._v("Saving Changes...")])]) : _vm._e(), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "text": ("You have " + (_vm.getProfile.activity_passes) + " RoundTable " + (_vm.getProfile.activity_passes === 1 ? 'credit' : 'credits')),
      "styleTooltip": "top-0 right-full -mt-1 mr-2 rounded-lg px-3 shadow-sm border border-solid border-gray-200",
      "textColor": "text-blueGray-800",
      "backgroundColor": "bg-white"
    }
  }, [(_vm.is_teacher && _vm.free_teacher_account) ? _c('div', {
    staticClass: "select-none flex items-center justify-center w-12 font-manrope text-gray-800 hover:bg-pink-100 cursor-pointer bg-pink-50 h-7 space-x-1.5 rounded-full"
  }, [_c('i', {
    staticClass: "fas fa-rocket text-pinky"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getProfile.activity_passes))])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "w-7 h-7 focus:ring-2 focus:ring-offset-2 focus:ring-primary-dark rounded-full cursor-pointer bg-gray-50 hover:bg-gray-100 text-base flex items-center justify-center hover:text-gray-800 text-gray-700",
    on: {
      "click": function($event) {
        return _vm.handleCloseDialog()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between items-center space-x-5 px-5 relative w-full mb-2.5 mt-2.5"
  }, [_c('div', {
    staticClass: "flex-grow"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "w-full text-3xl font-manrope font-bold text-gray-800 border-none bg-white py-1 outline-none",
    attrs: {
      "disabled": _vm.isGenerating,
      "placeholder": "Enter a title..."
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('button', {
    staticClass: "flex items-center space-x-3 hover:shadow-sm rounded-md border border-solid hover:bg-gray-50 border-gray-200 hover:border-primary px-4 py-1.5",
    class: {
      'border-primary': _vm.isToAddToPortfolio === true
    },
    on: {
      "click": function($event) {
        _vm.isToAddToPortfolio = !_vm.isToAddToPortfolio
      }
    }
  }, [_c('span', {
    staticClass: "text-gray-800"
  }, [_vm._v("Add Portfolio")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "is_checked": _vm.isToAddToPortfolio
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "disabled:opacity-50 flex items-center space-x-2 bg-primary hover:bg-primary-dark rounded-md border border-solid border-primary text-white py-1.5 px-4",
    attrs: {
      "disabled": _vm.isGenerating || _vm.isCreating ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.handleCreateRoundTable()
      }
    }
  }, [(_vm.isCreating === true) ? _c('div', {
    staticClass: "loader -ml-0.5"
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.isCreating === true ? 'Creating RoundTable...' : 'Create RoundTable'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-between w-full bg-white :disabled:bg-white h-11 focus-within:border-pinky border-b border-solid border-gray-200 pl-4 pr-5"
  }, [_c('div', {
    staticClass: "flex items-center w-full font-manrope"
  }, [_c('div', {
    staticClass: "w-14 h-14 -ml-3"
  }, [_c('iframe', {
    attrs: {
      "src": "https://lottie.host/embed/874b8bf3-ca7e-46f3-9c81-cf94974ad30b/Djg5qZsQK9.lottie",
      "width": "100%",
      "height": "100%"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.revise.input),
      expression: "revise.input"
    }],
    ref: "genieRevise",
    staticClass: "w-full disabled:bg-white border-none",
    attrs: {
      "placeholder": "How can I help you make this discussion prompt better?"
    },
    domProps: {
      "value": (_vm.revise.input)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleRevisePrompt()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.revise, "input", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-5"
  }, [_c('pl-menu', {
    attrs: {
      "direction": "right",
      "menuSize": 3
    }
  }, [_c('button', {
    staticClass: "flex items-center space-x-2.5 font-manrope text-gray-800",
    attrs: {
      "slot": "menu_trigger"
    },
    slot: "menu_trigger"
  }, [_c('span', [_vm._v(_vm._s(_vm.revise.mode))]), _vm._v(" "), _c('i', {
    staticClass: "fa-solid fa-chevron-down text-xs text-gray-600 hover:text-gray-800"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "flex flex-col space-y-1.5 rounded-lg mt-0.5 text-sm shadow-sm px-1 pt-0.5 pb-1 font-manrope max-h-96",
    attrs: {
      "menu-content": ""
    }
  }, [_c('li', {
    staticClass: "flex items-center space-x-1 justify-between hover:bg-gray-100 px-2.5 py-1 cursor-pointer rounded-md"
  }, [_c('span', [_vm._v("Prompt")]), _vm._v(" "), (_vm.revise.mode === 'Prompt') ? _c('i', {
    staticClass: "fa-solid fa-check text-gray-400"
  }) : _vm._e()]), _vm._v(" "), (_vm.type === 'written') ? _c('li', {
    staticClass: "flex justify-between space-x-1 text-gray-400 cursor-not-allowed items-center hover:bg-gray-100 px-2.5 py-1 rounded-md"
  }, [_c('span', [_vm._v("Selection")]), _vm._v(" "), (_vm.revise.mode === 'Selection') ? _c('i', {
    staticClass: "fa-solid fa-check text-gray-400"
  }) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "text-white w-8 h-6 rounded-lg flex justify-center items-center disabled:opacity-50 bg-pinky hover:bg-pinky-dark cursor-pointer",
    attrs: {
      "disabled": _vm.revise.input === '' || _vm.revise.input.length < 4 ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.handleRevisePrompt()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-arrow-right-long"
  })])], 1)]), _vm._v(" "), (_vm.isRevising === true || _vm.isGenerating === true) ? _c('div', {
    staticClass: "w-full"
  }, [_c('div', {
    staticClass: "h-0.5 w-full bg-pink-100 overflow-hidden"
  }, [_c('div', {
    staticClass: "progress w-full h-full bg-pink-500 left-right"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex items-start flex-grow h-full w-full",
    attrs: {
      "id": "editor"
    }
  }, [(_vm.isGenerating === false && _vm.options.length > 0) ? _c('div', {
    staticClass: "2xl:w-3/12 xl:w-4/12 lg:w-5/12 md:w-6/12 hidden md:block h-full py-3 border-r border-solid border-gray-200"
  }, [(_vm.genieOptions.length) ? _c('div', {
    staticClass: "flex flex-col space-y-4 px-3 mb-3"
  }, [_c('ul', {
    staticClass: "flex flex-col space-y-2 select-none"
  }, _vm._l((_vm.genieOptions), function(op, index) {
    return _c('li', {
      key: index,
      staticClass: "cursor-pointer flex flex-col space-y-2 w-full border border-solid border-gray-200 rounded-md px-4 py-3",
      on: {
        "click": function($event) {
          return _vm.handleChangeOption(op, 'genie')
        }
      }
    }, [_c('div', {
      staticClass: "flex justify-between items-center"
    }, [_c('h6', {
      staticClass: "text-xs font-manrope text-gray-600"
    }, [_vm._v("Draft Template " + _vm._s(index + 1))]), _vm._v(" "), _c('Checkbox', {
      attrs: {
        "is_checked": _vm.selected && _vm.selected.id === op.id
      }
    })], 1), _vm._v(" "), _c('h3', {
      staticClass: "font-manrope text-gray-800 font-bold"
    }, [_vm._v(_vm._s(op.title))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.universeOptions.length) ? _c('div', {
    staticClass: "flex flex-col space-y-2.5 px-3"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2.5"
  }, [_c('img', {
    staticClass: "w-6 h-6 rounded-full",
    attrs: {
      "src": "/static/roundtable_options_create/browse_universe.svg"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "font-manrope text-gray-800 font-bold"
  }, [_vm._v("From Parlay Universe")])]), _vm._v(" "), _c('button', {
    staticClass: "w-7 h-7 hover:bg-gray-100 rounded-full hover:text-pinky text-gray-800 text-xs",
    on: {
      "click": function($event) {
        return _vm.handleGoToUniverse()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-arrow-up-right-from-square"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "flex flex-col space-y-2 select-none"
  }, _vm._l((_vm.universeOptions), function(op, index) {
    return _c('li', {
      staticClass: "flex flex-col border border-solid px-4 py-3 rounded-md hover:border-primary",
      class: {
        'border-primary': _vm.selected.id === op.id,
        'border-gray-200': _vm.selected.id !== op.id
      },
      on: {
        "click": function($event) {
          return _vm.handleChangeOption(op, 'community')
        }
      }
    }, [_c('div', {
      staticClass: "flex items-center justify-between"
    }, [_c('span', {
      staticClass: "font-manrope text-gray-600 text-xs mb-1"
    }, [_vm._v("Option " + _vm._s(index + 1))]), _vm._v(" "), _c('Checkbox', {
      attrs: {
        "is_checked": _vm.selected && _vm.selected.id === op.id
      }
    })], 1), _vm._v(" "), _c('h6', {
      staticClass: "hover:underline cursor-pointer font-manrope font-bold mb-2"
    }, [_vm._v(_vm._s(op.title))]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center space-x-2"
    }, [_c('img', {
      staticClass: "w-5 h-5 rounded-full",
      attrs: {
        "src": op.avatar_url
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "font-light font-poppins text-gray-600 text-xs"
    }, [_vm._v(_vm._s(op.name))])])])
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-full h-full"
  }, [(_vm.type === 'written' && _vm.draft) ? _c('div', {
    staticClass: "w-full h-full"
  }, [_c('Editor', {
    ref: "editorWrittenPrompt",
    attrs: {
      "api-key": "no-api-key",
      "init": _vm.editor
    },
    model: {
      value: (_vm.written.prompt),
      callback: function($$v) {
        _vm.$set(_vm.written, "prompt", $$v)
      },
      expression: "written.prompt"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'verbal' && _vm.draft) ? _c('div', {
    staticClass: "h-full"
  }, [_c('div', {
    staticClass: "border-b border-solid border-gray-200",
    attrs: {
      "id": "toolbar-container"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pb-60 overflow-y-auto h-full"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('Editor', {
    ref: "editorVerbalPrompt",
    attrs: {
      "api-key": "no-api-key",
      "init": _vm.editorVerbal
    },
    model: {
      value: (_vm.verbal.instructions),
      callback: function($$v) {
        _vm.$set(_vm.verbal, "instructions", $$v)
      },
      expression: "verbal.instructions"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "px-16"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-5 font-manrope mb-8"
  }, [_c('h3', {
    staticClass: "text-2xl text-gray-800 font-bold"
  }, [_vm._v("\n                  Content & Multimedia\n                ")]), _vm._v(" "), (_vm.isGenerating === false) ? _c('div', {
    staticClass: "flex items-center space-x-2 w-full"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resource.resourceName),
      expression: "resource.resourceName"
    }],
    staticClass: "w-full bg-gray-100 border border-solid rounded-md border-gray-200 py-1.5 px-3.5 focus-within:ring-2 ring-offset-2 ring-primary",
    attrs: {
      "placeholder": "Enter a Resource Name..."
    },
    domProps: {
      "value": (_vm.resource.resourceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resource, "resourceName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.resource.resourceURL),
      expression: "resource.resourceURL"
    }],
    staticClass: "w-full bg-gray-100 border border-solid rounded-md border-gray-200 py-1.5 px-3.5 focus-within:ring-2 ring-offset-2 ring-primary",
    attrs: {
      "placeholder": "Enter a Resource URL..."
    },
    domProps: {
      "value": (_vm.resource.resourceURL)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleAddResource()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resource, "resourceURL", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "disabled:opacity-50 bg-blueGray-800 rounded-md px-4 py-1.5 text-white",
    attrs: {
      "disabled": _vm.resource.resourceName === '' && _vm.resource.resourceURL === '' ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.handleAddResource()
      }
    }
  }, [_vm._v("Add")])]) : _vm._e(), _vm._v(" "), (_vm.verbal.resources.length > 0 && _vm.isGenerating === false) ? _c('div', {
    staticClass: "w-full"
  }, [_c('ul', {
    staticClass: "flex flex-col"
  }, [_c('Draggable', {
    staticClass: "h-full flex-grow overflow-y-auto",
    attrs: {
      "handle": ".handle"
    },
    on: {
      "start": function($event) {
        _vm.isDragResource = true
      },
      "end": function($event) {
        _vm.isDragResource = false
      }
    },
    model: {
      value: (_vm.verbal.resources),
      callback: function($$v) {
        _vm.$set(_vm.verbal, "resources", $$v)
      },
      expression: "verbal.resources"
    }
  }, _vm._l((_vm.verbal.resources), function(r, index) {
    return _c('li', {
      key: index,
      staticClass: "flex items-center justify-between space-x-2 text-base mb-1 text-blue-600"
    }, [_c('div', {
      staticClass: "flex items-center space-x-2"
    }, [_c('button', {
      staticClass: "h-8 w-8 hover:bg-gray-100 rounded-full handle"
    }, [_c('i', {
      staticClass: "fa-solid fa-grip-vertical text-blueGray-600"
    })]), _vm._v(" "), _c('a', {
      staticClass: "hover:underline",
      attrs: {
        "href": r.resourceURL,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(r.resourceName))]), _vm._v(" "), _c('i', {
      staticClass: "fa-solid fa-arrow-up-right-from-square text-blue-500",
      staticStyle: {
        "font-size": "11px"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center space-x-2"
    }, [_c('div', {
      staticClass: "w-8 cursor-pointer h-5 flex items-center bg-gray-200 rounded-full p-1 duration-300 ease-in-out",
      class: {
        'bg-primary': r.is_active
      },
      attrs: {
        "title": "Hide Resource"
      },
      on: {
        "click": function($event) {
          return _vm.handleChangeResourceStatus(r.id)
        }
      }
    }, [_c('div', {
      staticClass: "bg-white w-3 h-3 rounded-full transform duration-300 ease-in-out",
      class: {
        'translate-x-3': r.is_active
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "flex items-center justify-center w-7 h-7 bg-gray-100 hover:bg-red-100 rounded-full text-red-500",
      attrs: {
        "title": "Remove"
      },
      on: {
        "click": function($event) {
          return _vm.handleDeleteResource(r.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa-solid fa-square-minus text-xs"
    })])])])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), (_vm.isGenerating === true) ? _c('div', [_c('div', {
    staticClass: "flex flex-col space-y-2.5 w-full animate-pulse"
  }, [_c('div', {
    staticClass: "h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-6/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3.5 bg-gray-300 rounded-full dark:bg-gray-700 w-8/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-5/12"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-5 font-manrope"
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('h3', {
    staticClass: "text-2xl text-gray-800 font-bold"
  }, [_vm._v("\n                    Questions\n                  ")])]), _vm._v(" "), (_vm.isGenerating === false) ? _c('div', {
    staticClass: "flex items-center space-x-2 w-full"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.question.question),
      expression: "question.question"
    }],
    staticClass: "w-full bg-gray-100 border border-solid rounded-md border-gray-200 py-1.5 px-3.5 focus-within:ring-2 ring-offset-2 ring-primary",
    attrs: {
      "placeholder": "Enter a Question..."
    },
    domProps: {
      "value": (_vm.question.question)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleAddQuestion()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.question, "question", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "bg-blueGray-800 disabled:opacity-50 rounded-md px-4 py-1.5 text-white",
    attrs: {
      "disabled": _vm.question.question === '' ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.handleAddQuestion()
      }
    }
  }, [_vm._v("Add")])]) : _vm._e(), _vm._v(" "), (_vm.verbal.questions.length > 0 && _vm.isGenerating === false) ? _c('div', {
    staticClass: "w-full"
  }, [_c('ul', {
    staticClass: "flex flex-col"
  }, [_c('Draggable', {
    staticClass: "h-full flex-grow overflow-y-auto",
    attrs: {
      "handle": ".handle-question"
    },
    on: {
      "start": function($event) {
        _vm.isDragQuestion = true
      },
      "end": function($event) {
        _vm.isDragQuestion = false
      }
    },
    model: {
      value: (_vm.verbal.questions),
      callback: function($$v) {
        _vm.$set(_vm.verbal, "questions", $$v)
      },
      expression: "verbal.questions"
    }
  }, _vm._l((_vm.verbal.questions), function(q, index) {
    return _c('li', {
      staticClass: "flex justify-between items-center space-x-2 text-base mb-1.5"
    }, [_c('div', {
      staticClass: "flex items-center space-x-2 w-full"
    }, [_c('button', {
      staticClass: "h-8 w-8 hover:bg-gray-100 focus-within:outline-none rounded-full handle-question cursor-move"
    }, [_c('i', {
      staticClass: "fa-solid fa-grip-vertical text-blueGray-600"
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (q.question),
        expression: "q.question"
      }],
      staticClass: "w-full border-none rounded",
      domProps: {
        "value": (q.question)
      },
      on: {
        "select": function($event) {
          return _vm.handleTextSelection($event, q)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(q, "question", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center space-x-3"
    }, [_c('div', {
      staticClass: "w-8 cursor-pointer h-5 flex items-center bg-gray-200 rounded-full p-1 duration-300 ease-in-out",
      class: {
        'bg-primary': q.is_active
      },
      attrs: {
        "title": "Hide Resource"
      },
      on: {
        "click": function($event) {
          return _vm.handleChangeQuestionStatus(q.id)
        }
      }
    }, [_c('div', {
      staticClass: "bg-white w-3 h-3 rounded-full transform duration-300 ease-in-out",
      class: {
        'translate-x-3': q.is_active
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "flex items-center justify-center w-7 h-7 bg-gray-100 hover:bg-red-100 focus-within:border-red-500 focus-within:border focus-within:border-solid focus-within:outline-none rounded-full text-red-500",
      attrs: {
        "title": "Remove"
      },
      on: {
        "click": function($event) {
          return _vm.handleDeleteQuestion(q.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa-solid fa-square-minus text-xs"
    })])])])
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), (_vm.isGenerating === true) ? _c('div', [_c('div', {
    staticClass: "flex flex-col space-y-2.5 w-full animate-pulse"
  }, [_c('div', {
    staticClass: "h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-6/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3.5 bg-gray-300 rounded-full dark:bg-gray-700 w-10/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3.5 bg-gray-200 rounded-full dark:bg-gray-700 w-6/12"
  }), _vm._v(" "), _c('div', {
    staticClass: "h-3.5 bg-gray-300 rounded-full dark:bg-gray-700 w-5/12"
  })])]) : _vm._e()])])])]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5497c28a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/Drafts/Index.vue
// module id = 946
// module chunks = 61